<template>
  <div class="gallery-section">
    <div class="container-fluid px-0">
      <div class="gallery-header">
        <h2 class="gallery-title">MŪSŲ DARBŲ GALERIJA</h2>
        <div class="gallery-divider"></div>
        <p class="gallery-subtitle">Peržiūrėkite mūsų atliktus projektus ir darbų kokybę</p>
      </div>
      
      <div class="gallery-grid">
        <div 
          v-for="(src, index) in displayedImages" 
          :key="index"
          class="gallery-item"
          @click="openImageModal(src)"
        >
          <img :src="src" :alt="`Projekto nuotrauka ${index + 1}`" class="gallery-image">
          <div class="gallery-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Load More Button -->
      <div v-if="hasMoreImages" class="gallery-load-more">
        <button @click="loadMore" class="load-more-btn">
          <span>Rodyti daugiau</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Full Image Modal -->
    <div 
      v-if="selectedImage" 
      class="gallery-modal-overlay"
      @click="closeImageModal"
    >
      <div class="gallery-modal">
        <button class="gallery-modal-close" @click="closeImageModal" aria-label="Uždaryti">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <img 
          :src="selectedImage.replace('-min.jpg', '.jpg')" 
          alt="Didelė nuotrauka"
          class="gallery-modal-image"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Gallery",
  data() {
    return {
      selectedImage: null,
      imagesPerPage: 12,
      imagesToShow: 12,
      images: [
        "/pictures/picture1-min.jpg",
        "/pictures/picture2-min.jpg",
        "/pictures/picture3-min.jpg",
        "/pictures/picture4-min.jpg",
        "/pictures/picture5-min.jpg",
        "/pictures/picture6-min.jpg",
        "/pictures/picture7-min.jpg",
        "/pictures/picture8-min.jpg",
        "/pictures/picture9-min.jpg",
        "/pictures/picture10-min.jpg",
        "/pictures/picture11-min.jpg",
        "/pictures/picture12-min.jpg",
        "/pictures/picture13-min.jpg",
        "/pictures/picture14-min.jpg",
        "/pictures/picture15-min.jpg",
        "/pictures/picture17-min.jpg",
        "/pictures/picture18-min.jpg",
        "/pictures/picture19-min.jpg",
        "/pictures/picture20-min.jpg",
        "/pictures/picture21-min.jpg",
      ]
    }
  },
  computed: {
    displayedImages() {
      return this.images.slice(0, this.imagesToShow)
    },
    hasMoreImages() {
      return this.imagesToShow < this.images.length
    }
  },
  methods: {
    openImageModal(image) {
      this.selectedImage = image
      document.body.style.overflow = 'hidden'
    },
    closeImageModal() {
      this.selectedImage = null
      document.body.style.overflow = ''
    },
    loadMore() {
      this.imagesToShow += 4
      // Smooth scroll to newly loaded images
      this.$nextTick(() => {
        const galleryGrid = document.querySelector('.gallery-grid')
        if (galleryGrid) {
          const lastItem = galleryGrid.lastElementChild
          if (lastItem) {
            lastItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          }
        }
      })
    }
  },
  watch: {
    selectedImage(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.gallery-section {
  background: white;
  padding: 80px 20px;
}

.gallery-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.gallery-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.gallery-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.gallery-subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto 40px;
}

@media (max-width: 1200px) {
  .gallery-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .gallery-grid {
    grid-template-columns: 1fr;
  }
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  aspect-ratio: 4/3;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.gallery-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 35px rgba(220, 53, 69, 0.3);
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.1);
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.8), rgba(255, 107, 107, 0.8));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.gallery-overlay svg {
  width: 48px;
  height: 48px;
  color: white;
}

/* Full Image Modal */
.gallery-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.gallery-modal {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
}

.gallery-modal-close {
  position: absolute;
  top: -50px;
  right: 0;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
  z-index: 10002;
}

.gallery-modal-close:hover {
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.5);
}

.gallery-modal-close svg {
  width: 24px;
  height: 24px;
}

.gallery-modal-image {
  max-width: 100%;
  max-height: 95vh;
  object-fit: contain;
  border-radius: 8px;
}

.gallery-load-more {
  text-align: center;
  margin-top: 40px;
}

.load-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  color: white;
  border: none;
  border-radius: 50px;
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.load-more-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);
}

.load-more-btn:active {
  transform: translateY(-1px);
}

.load-more-btn svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.load-more-btn:hover svg {
  transform: translateY(2px);
}

@media (max-width: 768px) {
  .gallery-section {
    padding: 60px 15px;
  }
  
  .gallery-modal-overlay {
    padding: 20px;
  }
  
  .gallery-modal-close {
    top: -40px;
    width: 40px;
    height: 40px;
  }

  .load-more-btn {
    padding: 14px 28px;
    font-size: 0.95rem;
  }
}
</style>